import { render, staticRenderFns } from "./messageDetail.vue?vue&type=template&id=e851e82a&scoped=true&"
import script from "./messageDetail.vue?vue&type=script&lang=js&"
export * from "./messageDetail.vue?vue&type=script&lang=js&"
import style0 from "./messageDetail.vue?vue&type=style&index=0&id=e851e82a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e851e82a",
  null
  
)

export default component.exports